import { _ as e, I as r, d as t, a as s, e as o, L as m } from "./ThemeProvider-d6d6b87f.js";
export { A as AspectRatio, B as BoundedBox, a as Box, b as Button, F as Flex, G as Grid, H as Heading, c as Input, S as SVG, T as Text } from "./ThemeProvider-d6d6b87f.js";
import n from "react";
import i from "styled-components";
export { ThemeProvider } from "styled-components";
import "styled-system";
import "styled-system-scale";
import { isInternal as f } from "@walltowall/helpers";
import p from "gatsby-image";
import { Link as d } from "gatsby";
var l = n.forwardRef(function (a, s) {
  var o = a.src,
      m = e(a, ["src"]);
  return o ? n.createElement(r, t({
    ref: s,
    src: o
  }, m)) : n.createElement(r, t({
    as: p,
    ref: s
  }, m));
});

function y() {
  var e = o(["\n  .gatsby-image-outer-wrapper,\n  .gatsby-image-wrapper {\n    height: 100%;\n  }\n"]);
  return y = function y() {
    return e;
  }, e;
}

l.displayName = "Image";
var g = i(s)(y());
g.displayName = "ImageContainer";
var h = n.forwardRef(function (r, a) {
  var s = r.href,
      o = e(r, ["href"]);
  return s && f(s) ? n.createElement(m, t({
    as: d,
    ref: a,
    to: s,
    href: s
  }, o)) : n.createElement(m, t({
    ref: a,
    href: s
  }, o));
});
h.displayName = "Link";
export { l as Image, g as ImageContainer, h as Link };